// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__wDq1e","spin":"Loader_spin__ddwRw","wrap":"Loader_wrap__FKFye","wrapBlock":"Loader_wrapBlock__ormOq"};